import React, { Fragment } from 'react';
// import About from './components/About';
import Section from '../../Section/Section';
import MeetingForm from '../../../components/Form/MeetingForm';
import aboutMeImg from '../../../assets/img/me/mePhoto.jpeg'


const AboutComponent = () => {
  return (
    <Section>
    {/* <Fade delay={300} direction="right"> */}
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-1 my-10 mt-16 mb-10">
      <div className="col-span-1 md:col-span-1 xl:col-span-2 flex flex-col justify-center xl:ml-6">
        <h2 className="text-5xl xl:text-4xl text-center xl:text-start  text-primary font-bold uppercase">
            Sobre mí
          </h2>
        <div className='grid grid-cols-1 xl:grid-cols-2'>
          <div className="col-span-2 xl:col-span-1 flex justify-center flex-col">
            <img
              src={aboutMeImg}
              alt="about-img"
              className="object-cover rounded-full shadow-lg h-[280px] w-[280px] mt-10 mx-20 md:mx-2 md:w-[300px] md:h-[300px] xl:w-[350px] xl:h-[350px] xl:my-10 xl:mx-20 hover:scale-110 duration-300"
            />
          </div>
          <div className="col-span-2 xl:col-span-1 ">
            <p className="text-lg xl:text-xl text-gray-700 mt-8 ml-0 xl:ml-1 xl:text-left">   
              SOLUCIONES INMOBILIARIAS REGIÓN DE LOS LAGOS se destaca en el sector de bienes raíces por ofrecer soluciones 
              integrales para la compra, venta, arriendo, mantenimiento y administración de propiedades en la región. 
              Nuestro compromiso con la excelencia, la ética y la transparencia nos guía en cada transacción, 
              brindando un servicio personalizado que supera las expectativas de nuestros clientes.
              <br />
              <br />
              Con un equipo de profesionales altamente capacitados y una amplia experiencia en el mercado inmobiliario, 
              nos dedicamos a entender las necesidades individuales de cada cliente para ofrecer asesoramiento experto 
              y acompañamiento durante todo el proceso. En SOLUCIONES INMOBILIARIAS REGIÓN DE LOS LAGOS, 
              nos esforzamos por ser su aliado de confianza en la gestión de sus propiedades, asegurando una 
              experiencia satisfactoria y exitosa en cada interacción.
              <br />
            </p>
            <p className="text-lg xl:text-xl text-gray-700 mt-8 ml-0 xl:ml-1 md:text-center xl:text-left">
              Nancy Carvajal Flores.
            </p>
            <p className="text-xl xl:text-xl text-gray-700 ml-0 xl:ml-1 md:text-center xl:text-left">
              Fundador y Gerente General de Natka.
            </p>
          </div>
        </div>
      </div>
    </div>
    {/* </Fade>  */}
  </Section>
  );
};

export default AboutComponent;
